// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapType_container__FdN7b {
    padding: 16px;
}

.MapType_mapTypeSelector__\\+2BFi {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    background-size: 50px 50px;
    background-repeat: no-repeat;
    background-position: center center;
    border-bottom: 1px solid var(--color-lightui-surface-4);
    padding: 0px;
}

.MapType_placeholderContainer__8JqYL {
    width:52px;
    height:52px;
}

.MapType_mapTypeName__zAd1T {
    text-align: center;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.MapType_typeContainer__9NblA {
    position: relative;
    z-index: 10000;
    color: var(--color-darkui-accent-2);
    text-transform: capitalize;
    text-align: center;
}

.MapType_typeButton__B1MAY {
    text-align: center;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10001;
    opacity: 0.0;
}


.MapType_selected__U6cXF {
   border: 2px solid var(--color-blue-light-3);
}

.MapType_unselected__pFkql {
    border: 2px solid white;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Maps/components/MapType.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,uDAAuD;IACvD,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mCAAmC;IACnC,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;;AAGA;GACG,2CAA2C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB","sourcesContent":[".container {\n    padding: 16px;\n}\n\n.mapTypeSelector {\n    width: 50px;\n    height: 50px;\n    border-radius: 4px;\n    background-size: 50px 50px;\n    background-repeat: no-repeat;\n    background-position: center center;\n    border-bottom: 1px solid var(--color-lightui-surface-4);\n    padding: 0px;\n}\n\n.placeholderContainer {\n    width:52px;\n    height:52px;\n}\n\n.mapTypeName {\n    text-align: center;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.typeContainer {\n    position: relative;\n    z-index: 10000;\n    color: var(--color-darkui-accent-2);\n    text-transform: capitalize;\n    text-align: center;\n}\n\n.typeButton {\n    text-align: center;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10001;\n    opacity: 0.0;\n}\n\n\n.selected {\n   border: 2px solid var(--color-blue-light-3);\n}\n\n.unselected {\n    border: 2px solid white;\n    border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MapType_container__FdN7b`,
	"mapTypeSelector": `MapType_mapTypeSelector__+2BFi`,
	"placeholderContainer": `MapType_placeholderContainer__8JqYL`,
	"mapTypeName": `MapType_mapTypeName__zAd1T`,
	"typeContainer": `MapType_typeContainer__9NblA`,
	"typeButton": `MapType_typeButton__B1MAY`,
	"selected": `MapType_selected__U6cXF`,
	"unselected": `MapType_unselected__pFkql`
};
export default ___CSS_LOADER_EXPORT___;
